<template>
  <div id="404">
    <BottomBar />
    <Empty
      :icon="true"
      icon-class="anyteach-error2"
      title="404"
      subtitle="抱歉，找不到您要查看的页面"
      link="/courses"
      link-text=" 查看课程"
    />
  </div>
</template>
<script>
export default {
  name: "404",
}
</script>
<style scoped lang="scss">
</style>
